import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["source", "followUp"];

  connect() {
    this.customized = this.followUpTarget.value !== "" &&
      this.followUpTarget.value !== this.sourceTarget.value;
    this.sync();
  }

  sync() {
    if (!this.customized) this.followUpTarget.value = this.sourceTarget.value;
  }

  customize() {
    this.customized = true;
  }
}
